import { Component, Input } from '@angular/core';

import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

@Component({
  selector: 'app-news-card',
  standalone: true,
  imports: [AnimateOnScrollDirective],
  templateUrl: './news-card.component.html',
})
export class NewsCardComponent {
  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() date: string = '';
  @Input() description: string = '';
  @Input() url: string = '';

  /**
   * Verifica se a URL é válida e pode ser usada
   */
  get hasValidUrl(): boolean {
    return !!(this.url && this.url !== '#' && this.url.trim().length > 0);
  }
}
